import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SystemSection } from '../components/SystemSection';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-carbon text-white selection:bg-gold/30 selection:text-gold font-sans" lang="es" data-id="element-35">
      <main data-id="element-36">
        <HeroSection data-id="element-37" />
        <SystemSection data-id="element-38" />
        <FinalCTA data-id="element-39" />
      </main>
    </div>;
}